import { render, staticRenderFns } from "./TabButton.vue?vue&type=template&id=51d71b8c&scoped=true"
import script from "./TabButton.vue?vue&type=script&lang=ts"
export * from "./TabButton.vue?vue&type=script&lang=ts"
import style0 from "./TabButton.vue?vue&type=style&index=0&id=51d71b8c&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d71b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d71b8c')) {
      api.createRecord('51d71b8c', component.options)
    } else {
      api.reload('51d71b8c', component.options)
    }
    module.hot.accept("./TabButton.vue?vue&type=template&id=51d71b8c&scoped=true", function () {
      api.rerender('51d71b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FloatingTabs/TabButton.vue"
export default component.exports